export default __webpack_public_path__ + "static/media/9.7b95ca3b.webp";